
import { defineComponent, ref } from "vue";
import NumberedStat from "./NumberedStat.vue";
import IconVue from "./Icon.vue";
import { useStore } from "@/store";

export default defineComponent({
  components: {
    NumberedStat,
    IconVue
  },
  setup() {},
  computed: {
    internships() {
      return useStore().state.work.filter(w => w.tags.includes('internship') && !w.hidden);
    },
    research() {
      return useStore().state.work.filter(w => w.tags.includes('research') && !w.hidden);
    },
    classes() {
      return useStore().state.courses;
    },
    projects() {
      return useStore().state.projects;
    },
    languages() {
      return ['C++', 'Java', 'Python', 'C', 'Typescript', 'Javascript', 'MATLAB', 'Go', 'Julia', 'Bash']
    },
    focuses() {
      return ['High Performance Standards', 'Robust System Design', 'Intuitive Interfaces']
    }
  }
});
